var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 120,
    viewBox: "0 0 200 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28635",
    "data-name": "Group 28635",
    transform: "translate(-1088 -572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13582",
    "data-name": "Rectangle 13582",
    width: 200,
    height: 120,
    rx: 4,
    transform: "translate(1088 572)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28634",
    "data-name": "Group 28634",
    transform: "translate(653.139 21.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28632",
    "data-name": "Group 28632",
    transform: "translate(511.861 600.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47091",
    "data-name": "Path 47091",
    d: "M541.673,723.516a2.433,2.433,0,0,0-2,1.429l-11.184,19.372c-1.032-1.791-4.8-8.308-4.8-8.308a2.113,2.113,0,0,0-4,0s-4.579,7.933-5.681,9.839l-1.681,2.913c-1.1,1.905-.2,3.461,2,3.461h41.092c2.2,0,3.1-1.555,2-3.461l-13.751-23.815a2.427,2.427,0,0,0-2-1.429Z",
    transform: "translate(-511.861 -723.516)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28633",
    "data-name": "Group 28633",
    transform: "translate(518.123 592.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47092",
    "data-name": "Path 47092",
    d: "M623.033,592.383a5.56,5.56,0,1,1-5.56,5.56A5.559,5.559,0,0,1,623.033,592.383Z",
    transform: "translate(-617.473 -592.383)",
    fill: "#d8d8d8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageThumbnail);
export default __webpack_public_path__ + "static/media/ImageThumbnail.c59818d5.svg";
export { ForwardRef as ReactComponent };